import { type UseMutationResult, useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import ToastComponent from '../../components/toast';
import {
  AdvisorApiCredentialService,
  type Wealthlane_Dtos_AdvisorApi_AdvisorApiCredentialDto,
  type Wealthlane_Dtos_AdvisorApi_UpdateAdvisorApiCredentialDto,
} from '@wealthlane/api-services/wealthlane-identity-service';

const usePutAdvisorApiCredential = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  successMessage = 'Advisor API key updated successfully.',
): UseMutationResult<
  Wealthlane_Dtos_AdvisorApi_AdvisorApiCredentialDto | undefined,
  unknown,
  Wealthlane_Dtos_AdvisorApi_UpdateAdvisorApiCredentialDto,
  unknown
> => {
  const queryClient = useQueryClient();

  return useMutation(
    async (payload) => {
      return await handleRequest(
        AdvisorApiCredentialService.putApiIdentityApiAppAdvisorApiCredential(payload),
      );
    },
    {
      onSuccess: (data) => {
        if (data != null) {
          void queryClient.invalidateQueries('getAdvisorApiCredentialList');
          toast.success(<ToastComponent label='Success' message={successMessage} />);
        }
      },
    },
  );
};

export default usePutAdvisorApiCredential;
